export default __webpack_public_path__ + "static/media/selectedroomicon1.4e09312f.svg";